import ModalChangePassword from './ModalChangePassword';
export default ModalChangePassword;
